<template>
  <div class="vx-row" v-if="!loading">
    <div class="vx-col w-full lg:w-2/3">
      <vs-card>
        <div slot="header">Vidéo</div>
        <div>
          <video-player
            v-if="chat.composition_path"
            ref="player"
            class="media-video-player"
            :options="playerOptions(media)"
            v-once
          />
          <div style="text-align: center;" v-else>
            <h1 style="color: red;">La vidéo n'est pas encore prête veuillez patienter.</h1>
          </div>
        </div>
      </vs-card>
    </div>
    <div class="vx-col w-full lg:w-1/3">
      <vs-card>
        <div slot="header">Détails du Live</div>
        <vs-list v-if="!loading">
          <vs-list-item
            title="Présentateur:"
            :subtitle="chat.user.lastname + ' ' + chat.user.firstname"
          ></vs-list-item>
          <vs-list-item
            title="Date début du live"
            :subtitle="chat.date_start ? chat.date_start : chat.created_at"
          ></vs-list-item>
          <vs-list-item
            title="Durée du live"
            :subtitle="getDateDiff(chat.date_start, chat.date_end)"
          ></vs-list-item>
          <!--<vs-list-item
            title="Nombre d'agents connectés lors de la session"
            :subtitle="extractUserOnline(chat.chat_messages)"
          ></vs-list-item>-->
        </vs-list>
      </vs-card>
    </div>

    <div class="vx-col w-full lg:w-2/3">
      <vs-card>
        <div slot="header">
          <h5>Liste des agents concernées ({{participants.length}})</h5>
        </div>
        <div class="data-list-container">
          <vs-table ref="table" v-if="!loading" :data="participants" search>
            <div
              slot="header"
              class="flex flex-wrap-reverse items-center flex-grow justify-between"
            >
              <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                <div
                  @click="Export()"
                  class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                >
                  <feather-icon icon="DownloadCloudIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2 text-base text-primary">Exporter</span>
                </div>
              </div>
            </div>

            <template slot="thead">
              <vs-th sort-key="agency">Agences</vs-th>
              <vs-th sort-key="team">Equipes</vs-th>
              <vs-th sort-key="user">Utilisateurs</vs-th>
              <vs-th sort-key="joined">A participé ?</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].agency">{{ data[indextr].agency }}</vs-td>

                <vs-td :data="data[indextr].team">{{ data[indextr].team }}</vs-td>

                <vs-td :data="data[indextr].user">{{ data[indextr].user }}</vs-td>

                <vs-td :data="data[indextr].joined">
                  <vs-chip
                    :color="data[indextr].joined ? 'success' : 'danger'"
                  >{{data[indextr].joined ? 'OUI' : 'NON'}}</vs-chip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <br />
          <vs-row>
            <vs-col vs-offset="5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
              <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </div>

    <div class="vx-col w-full lg:w-1/3">
      <vs-card>
        <div slot="header">
          <h5>Messages envoyés</h5>
        </div>
        <div v-if="!loading">
          <div class="chat-box">
            <vs-col vs-offset="0">
              <vs-list>
                <vs-list-item class="chat-item">
                  <div class="chat-status text-center">
                    <span class="chat-content-center">{{ chat.name }}</span>
                  </div>

                  <div v-for="(item, index) in chat.chat_messages" :key="index">
                    <div class="chat-message text-right" v-if="getConnectedUser(item.user_id)">
                      <div class="right-bubble">
                        <span class="msg-name">Moi</span>
                        <span class="msg-date">{{ item.created_at}}</span>
                        <p text-wrap>{{ item.comment }}</p>
                      </div>&nbsp;
                    </div>

                    <div class="chat-message text-left" text-left v-else>
                      <div class="left-bubble">
                        <span class="msg-name">{{ item.user.lastname + ' ' + item.user.firstname}}</span>
                        <span class="msg-date">{{ item.created_at }}</span>
                        <p text-wrap>{{ item.comment }}</p>
                      </div>&nbsp;
                    </div>
                  </div>
                </vs-list-item>
              </vs-list>
            </vs-col>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { _buildQuery } from "../../helpers/buildquery";
import moment from "moment";

export default {
  name: "show",
  data: () => ({
    loading: false,
    participants: [],
    chat: {},
    videoUrl: "",
    swiperOption: {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    },
    last_page: null,
    page: 1,
  }),
  watch: {
    page(value) {
      this.getParticipants(value);
    },
  },
  computed: {
    media() {
      return {
        sources: [
          {
            type:
              "video/" +
              this.videoUrl.split(".")[this.videoUrl.split(".").length - 1],
            src: this.videoUrl,
          },
        ],
        //sources: [{ type: "video/mp4", src: this.videoUrl }],
        poster: "https://goo.gl/xcCsDd",
      };
    },
    playerOptions() {
      return (media) => {
        return {
          height: "360",
          fluid: true,
          autoplay: false,
          muted: false,
          language: "fr",
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: media.sources,
          poster: media.poster,
        };
      };
    },
  },
  created() {
    this.loadLiveTchatDetails();
    this.getParticipants(this.page);
  },
  methods: {
    getDateDiff(start, end) {
      // console.log

      return moment
        .utc(
          moment(end, "YYYY-MM-DD HH:mm:ss").diff(
            moment(start, "YYYY-MM-DD HH:mm:ss")
          )
        )
        .format("HH:mm:ss");
    },
    getConnectedUser(id) {
      const user = JSON.parse(localStorage.getItem("userInfo"));
      if (user) {
        if (user.id === id) {
          return true;
        } else return false;
      }
    },
    async loadLiveTchatDetails() {
      this.loading = true;
      const chat_id = this.$route.params.id;
      this.$vs.loading();

      try {
        const response = await axios.get("chats/" + chat_id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
        });
        this.loading = false;
        this.$vs.loading.close();
        this.chat = response.data;
        this.videoUrl = response.data.composition_path;
      } catch (error) {
        if (error.response) {
          this.loading = false;
          this.$vs.loading.close();
        }
      }
    },
    getParticipants(page) {
      this.$vs.loading()
      //this.loading = true;
      const params = {
        page: page,
        limit: 5,
      };
      this.$http
        .get("chats-show-teams/" + this.$route.params.id + _buildQuery(params))
        .then((response) => {
          //this.loading = false;
          this.participants = response.data.data;
          //console.log(this.participants)
          this.last_page = response.data.last_page;
          this.$vs.loading.close()
        });
    },
    async Export() {
      this.$vs.loading();

      const response = await this.$http.get(
        "export/chats-show-teams/" + this.$route.params.id,
        {
          headers: {
            responseType: "blob",
          },
        }
      );
      const link = document.createElement("a");
      link.href = response.data.info;
      link.setAttribute("download", "export_chat_users.xlsx");
      document.body.appendChild(link);
      link.click();
      this.$vs.loading.close();
    },
    extractUserOnline(chatMessages) {
      var online_users = [];
      if (chatMessages.length > 0) {
        const online_user_id = JSON.parse(localStorage.getItem("userInfo")).id;
        console.log(online_user_id);
        for (let index = 0; index < chatMessages.length; index++) {
          const element = chatMessages[index];
          if (element.joined && element.user_id !== online_user_id) {
            if (online_users.indexOf(element) === -1) {
              online_users.push(element)
            }
          }
        }
      }
      //console.log(JSON.stringify(chatMessages))

      return online_users.length.toString;
    },
  },
};
</script>

<style>
.chat-box {
  height: 500px;
  width: 100%;
  overflow: scroll;
}
.chat-item {
  border: none;
}
.chat-status {
  min-height: 49px;
}
.chat-status .chat-date {
  display: block;
  font-size: 10px;
  font-style: italic;
  color: #999;
  height: 15px;
  left: 10%;
  right: 10%;
}
.chat-status .chat-content-center {
  padding: 5px 10px;
  background-color: #e1e1f7;
  border-radius: 6px;
  font-size: 12px;
  color: #555;
  height: 34px;
  left: 10%;
  right: 10%;
}
.chat-message {
  width: 80%;
  min-height: 40px;
}
.chat-message .right-bubble {
  position: relative;
  background: #dcf8c6;
  border-top-left-radius: 0.4em;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  padding: 5px 10px 10px;
  left: 15%;
}
.chat-message .right-bubble span.msg-name {
  font-size: 12px;
  font-weight: bold;
  color: green;
  display: block;
}
.chat-message .right-bubble span.msg-date {
  font-size: 10px;
  display: block;
}
.chat-message .right-bubble:after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  border: 27px solid transparent;
  border-left-color: #dcf8c6;
  border-right: 0;
  border-top: 0;
  margin-top: -0.5px;
  margin-right: -27px;
}
.chat-message .left-bubble {
  position: relative;
  background: #efefef;
  border-top-right-radius: 0.4em;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  padding: 5px 10px 10px;
  left: 5%;
}
.chat-message .left-bubble span.msg-name {
  font-size: 12px;
  font-weight: bold;
  color: blue;
  display: block;
}
.chat-message .left-bubble span.msg-date {
  font-size: 10px;
  display: block;
}
.chat-message .left-bubble:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border: 27px solid transparent;
  border-right-color: #efefef;
  border-left: 0;
  border-top: 0;
  margin-top: -0.5px;
  margin-left: -27px;
}
footer.sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background-color: #ffffff;
  border-top: solid 1px #efefef;
}
</style>